<template>
    <div>
        <div class="page-group-title"><span>奖品设置</span></div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/lottery/prize/edit')" type="primary" icon="el-icon-plus" size="small" @click="add">添加奖品</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="lotteryPrizeList"
                border
                style="width: 100%"
                v-loading="dataLoading"
                size="small"
                stripe
            >
                <el-table-column prop="name" label="名称" min-width="200" show-overflow-tooltip>
                </el-table-column>
                <el-table-column label="图片">
                    <template slot-scope="scope">
                        <el-image v-if="scope.row.pic" :src="scope.row.pic" fit="contain" style="width:30px"></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="type" label="奖品类型">
                    <template slot-scope="scope">
                        <p v-if="scope.row.type == 1">无</p>
                        <p v-else-if="scope.row.type == 2">优惠券</p>
                        <p v-else-if="scope.row.type == 3">普通奖品</p>
                        <p v-else>演出赠票</p>
                    </template>
                </el-table-column>
				<el-table-column prop="collectionType" label="信息收集类型">
                    <template slot-scope="scope">
						<p v-if="scope.row.collectionType == 0">无</p>
                        <p v-if="scope.row.collectionType == 1">地址</p>
                        <p v-else-if="scope.row.collectionType == 2">实名</p>
                    </template>
                </el-table-column>
                <el-table-column prop="totalNum" label="发放总量">
                </el-table-column>
                <el-table-column prop="useNum" label="已发放">
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/lottery/prize/edit')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="edit(scope.row)"
                            >编辑</el-button
                        >
                        <el-button
                            v-if="$utils.have('/lottery/prize/delete')"
                            type="text"
                            size="small"
                            icon="el-icon-delete"
                            @click="del(scope.row.id)"
                            >删除</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <prize-edit ref="prizeEdit" @onUpdate="getDataDetail"></prize-edit>

        <div class="page-group-title"><span>转盘设置</span></div>
        <div class="lotteryNumControl">
            概率基数：<template v-if="lotteryNum || lotteryNumEdit.isEdit"> 1 至 </template>
            <template v-if="!lotteryNumEdit.isEdit">
                {{lotteryNum}}
                <el-button size="mini" @click="editLotteryNum">{{lotteryNum ? '修改' : '设置'}}</el-button>
            </template>
            <template v-else>
                <el-input-number v-model="lotteryNumEdit.lotteryNum" :precision="0" :min="lotteryNumMin" :max="99999999" size="mini"></el-input-number>&nbsp;
                <el-button type="primary" size="mini" @click="saveLotteryNum" :loading="lotteryNumEdit.loading">保存</el-button>
            </template>
        </div>
        <div class="page-list-box">
            <el-form label-position="line" :model="formData" ref="formData">
                <el-table
                    :data="lotteryConfigList"
                    border
                    style="width: 100%"
                    v-loading="dataLoading"
                    size="small"
                    stripe
                >
                    <el-table-column prop="position" label="转盘位置" width="90">
                    </el-table-column>
                    <el-table-column prop="prizeId" label="奖品" min-width="150">
                        <template slot-scope="scope">
                            <el-form-item :prop="`lotteryConfigList[${scope.$index}].prizeId`" :rules="[{required: true, message: '请选择奖品'}]">
                                <el-select size="mini" v-model="scope.row.prizeId">
                                    <el-option v-for="item in lotteryPrizeList" :key="item.id" :value="item.id" :label="item.name"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="转到范围" min-width="300">
                        <template slot-scope="scope">
                            <!-- <span v-if="scope.$index == 0">{{scope.row.rangeStart}}</span> -->
                            <el-row type="flex">
                                <span>
                                    <el-form-item :prop="`lotteryConfigList[${scope.$index}].rangeStart`" :rules="[{required: true, message: '不能为空'}]">
                                        <el-input-number 
                                            :disabled="scope.$index == 0 ? true : false" 
                                            v-model="scope.row.rangeStart" 
                                            :precision="0" 
                                            :min="scope.$index > 0 ? lotteryConfigList[scope.$index - 1].rangeEnd + 1 : 1" 
                                            :max="Math.min(scope.row.rangeEnd,lotteryNum)" 
                                            size="mini"
                                            @change="setLotteryNumMin">
                                        </el-input-number>
                                        至&nbsp;
                                    </el-form-item>
                                </span>
                                <span>
                                    <el-form-item :prop="`lotteryConfigList[${scope.$index}].rangeEnd`" :rules="[{required: true, message: '不能为空'}]">
                                        <el-input-number 
                                            v-model="scope.row.rangeEnd" 
                                            :precision="0" 
                                            :min="scope.row.rangeStart ? scope.row.rangeStart : 1" 
                                            :max="Math.min(lotteryConfigList[scope.$index + 1] && lotteryConfigList[scope.$index + 1].rangeStart && lotteryConfigList[scope.$index + 1].rangeStart - 1 || lotteryNum , lotteryNum)" 
                                            size="mini"
                                            @change="setLotteryNumMin">
                                        </el-input-number>
                                    </el-form-item>
                                </span>
                            </el-row>
                        </template>
                    </el-table-column>
                    <el-table-column label="转到概率" width="90">
                        <template slot-scope="scope">
                            {{ (((scope.row.rangeEnd - scope.row.rangeStart + 1) / lotteryNum) * 100).toFixed(2)}}%
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>
            <div v-if="lotteryPrizeList && lotteryPrizeList.length > 0 && lotteryNum && (lotteryNumMin < lotteryNum || lotteryNumMin == lotteryNum && lotteryConfigList.length < 1)" class="MT20">
                <el-button icon="el-icon-plus" type="primary" plain style="width:100%" @click="addLotteryConfig">添加转盘</el-button>
            </div>
            <!-- <div class="color-danger MT20"><span class="el-icon-warning"></span>转到范围值之间必须不可相交且最大值不能超过概率基数</div> -->
        </div>
        <div class="page-btns-box MT30">
            <el-button @click="goBack">上一步</el-button>
            <el-button 
                v-if="$utils.have('/lottery/config/edit')" 
                :disabled="!lotteryConfigList || lotteryConfigList.length < 1 ? true : false"
                type="primary" 
                @click="onSubmit" 
                :loading="btnLoading"
            >保存</el-button>
        </div>
    </div>
</template>
<script>
import PrizeEdit from './components/PrizeEdit.vue'
export default {
    props:{
        id:{
            type: [String,Number],
            default: ''
        }
    },
    components:{PrizeEdit},
    data(){
        return{
            lotteryNum: "",
            lotteryPrizeList: null,
            lotteryConfigList: null,
            dataLoading: false,
            lotteryNumEdit:{
                isEdit: false,
                lotteryNum: 2,
                loading: false
            },
            btnLoading: false,
            lotteryNumMin: 2,
            formData:{},
            redirect: this.$route.query.redirect,
        }
    },
    mounted(){
        this.getDataDetail();
    },
    methods:{
        //获取详情
        getDataDetail(){
            this.dataLoading = true;
            this.$request({
                url: "/lottery/config/detail",
                params: { lotteryActivityId: this.id },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.lotteryNum = result.lotteryNum;
                        this.lotteryPrizeList = result.lotteryPrizeList;
                        this.lotteryConfigList = result.lotteryConfigList || [];
                        this.lotteryNumEdit.lotteryNum = result.lotteryNum || 2;
                        this.formData.lotteryConfigList = result.lotteryConfigList;

                        this.setLotteryNumMin();
                    } else {
                        this.$message.error(msg || "获取活动信息失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取活动信息失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //编辑奖品
        edit(data){
            this.$refs.prizeEdit.show({
                ...data,
                activityId:this.id
            })
        },
        //新增奖品
        add(){
            this.$refs.prizeEdit.show({
                activityId:this.id
            })
        },
        //删除奖品
        del(id){
            this.$confirm('删除后不可恢复，确定要删除该奖品吗？', '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.dataLoading = true;
                this.$request({
                    url: '/lottery/prize/delete',
                    method: 'POST',
                    params: {id:id}
                }).then(res => {
                    const { state, msg } = res.data;
                    if( state == 1 ){
                        this.getDataDetail();
                    }else{
                        this.$message.error(msg || '请求失败');
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                }).finally(() => {
                    this.dataLoading = false;
                });
            }).catch(() => {})
        },
        setLotteryNumMin(){
            this.$nextTick(() => {
                let arrs = this.lotteryConfigList.map(item => {
                    return item.rangeEnd;
                });
                
                this.lotteryNumMin = arrs.length > 0 ? Math.max(...arrs) : 2;
            })
        },
        //修改抽奖基数
        editLotteryNum(){
            this.setLotteryNumMin();
            this.lotteryNumEdit.isEdit = true
        },
        saveLotteryNum(){
            this.lotteryNumEdit.loading = true;
            this.$request({
                url: "/lottery/activity/editLotteryNum",
                params: { 
                    lotteryActivityId: this.id,
                    lotteryNum: this.lotteryNumEdit.lotteryNum
                },
                method: "post",
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1) {
                        this.lotteryNum = this.lotteryNumEdit.lotteryNum;
                        this.lotteryNumEdit.isEdit = false;
                        this.$message.success("修改成功");
                    } else {
                        this.$message.error(msg || "操作失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    this.lotteryNumEdit.loading = false;
                });
        },
        //提交
        onSubmit(){
            this.$refs["formData"].validate((valid,label) => {
                if(valid){
                    if( this.lotteryNumMin > this.lotteryNum){
                        return this.$message.error('【概率基数】需要大于或等于【转到范围】最大值，请重新填写');
                    }
                    this.btnLoading = true;
                    this.$request({
                    url: "/lottery/config/edit",
                    data: { 
                        lotteryActivityId: this.id,
                        configList: this.lotteryConfigList
                    },
                    method: "post",
                })
                    .then((res) => {
                        const { state, msg } = res.data;
                        if (state == 1) {
                            this.$router.push(this.redirect);
                        } else {
                            this.$message.error(msg || "操作失败,请重试");
                        }
                    })
                    .catch(() => {
                        this.$message.error("操作失败,请重试");
                    })
                    .finally(() => {
                        this.btnLoading = false;
                    });
                }
            })
        },
        //
        goBack(){
            this.$router.push({
                path:`/promotion/lottery/edit/${this.id}/step1`,
                query: {
                    redirect: this.redirect,
                },
            })
        },
        //添加转盘
        addLotteryConfig(){
            const _len = this.lotteryConfigList.length;
            console.log(this.lotteryConfigList)
            const _item = {
                position: _len+1,
                prizeId: "",
                rangeStart: this.lotteryConfigList[_len-1] && this.lotteryConfigList[_len-1].rangeEnd ? this.lotteryConfigList[_len-1].rangeEnd + 1 : 1,
                rangeEnd: this.lotteryConfigList[_len-1] && this.lotteryConfigList[_len-1].rangeEnd ? this.lotteryConfigList[_len-1].rangeEnd + 2 : 2,
            }
            this.lotteryConfigList.push(_item);
            this.setLotteryNumMin();
        }
    }
}
</script>
<style lang="scss" scoped>

</style>